module.exports = __webpack_public_path__ + "img/product_66.70f3fbb.webp";